import * as React from 'react';

const SearchIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={19} height={19} viewBox="0 0 19 19" {...props}>
        <defs>
            <filter
                id="searchicon_a"
                width="113.3%"
                height="183.3%"
                x="-6.7%"
                y="-33.3%"
                filterUnits="objectBoundingBox"
            >
                <feOffset dy={4} in="SourceAlpha" result="shadowOffsetOuter1" />
                <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation={6} />
                <feComposite in="shadowBlurOuter1" in2="SourceAlpha" operator="out" result="shadowBlurOuter1" />
                <feColorMatrix
                    in="shadowBlurOuter1"
                    result="shadowMatrixOuter1"
                    values="0 0 0 0 0.229949097 0 0 0 0 0.461254077 0 0 0 0 0.62647192 0 0 0 0.04 0"
                />
                <feOffset dy={2} in="SourceAlpha" result="shadowOffsetOuter2" />
                <feGaussianBlur in="shadowOffsetOuter2" result="shadowBlurOuter2" stdDeviation={2} />
                <feComposite in="shadowBlurOuter2" in2="SourceAlpha" operator="out" result="shadowBlurOuter2" />
                <feColorMatrix
                    in="shadowBlurOuter2"
                    result="shadowMatrixOuter2"
                    values="0 0 0 0 0.231372549 0 0 0 0 0.462745098 0 0 0 0 0.62745098 0 0 0 0.02 0"
                />
                <feMerge>
                    <feMergeNode in="shadowMatrixOuter1" />
                    <feMergeNode in="shadowMatrixOuter2" />
                </feMerge>
            </filter>
            <rect id="searchicon_b" width={300} height={48} x={0} y={0} rx={24} />
        </defs>
        <g fill="none" fillRule="evenodd">
            <path d="M-270-96H50v1792h-320z" />
            <g transform="translate(-260 -14)">
                <use xlinkHref="#searchicon_b" fill="currentColor" filter="url(#searchicon_a)" />
                <rect width={299} height={47} x={0.5} y={0.5} stroke="#DCE2E3" strokeLinejoin="miter" rx={23.5} />
            </g>
            <g
                fillRule="nonzero"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                transform="translate(-2 -2)"
            >
                <circle cx={9.491} cy={9.49} r={6.713} transform="rotate(-23.025 9.491 9.49)" />
                <path d="m14.238 14.237 5.206 5.207" />
            </g>
        </g>
    </svg>
);
export default SearchIcon;
